/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react'
// import moment from 'moment';
import { connect, useDispatch } from 'react-redux'
import { Button, message, Spin } from 'antd'
import { Rate } from 'antd';
import { CaretDownFilled } from '@ant-design/icons'
import { Space, Menu, Dropdown, Modal } from 'antd';
import { history } from 'redux/store'
import { storageData, clearstorageData } from 'redux/storage'
import { withTranslation, useTranslation } from 'react-i18next'
import musesAI from 'images/MusesAI.png'
import { toSubscription, preorderCreate, guestGetServicev2 } from 'api/hub'

const ServiceCard = (props) => {
  // i18n language switch
  const [LoadingStatus, setLoadingStatus] = useState(false)
  const [height, setHeight] = useState(50)
  const [loading, setLoading] = useState(false)
  const ref = useRef(null)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const ifpreorder = props.data.preorder === "Y" && props.data.subscription_id !== "N" ? true : false
  const ifForm = props.data.preorder === "F" ? true : false
  const [isModalOpen, setIsModalOpen] = useState(false)

  const ServiceCardModal = () => {
    const [loading, setLoading] = useState(false)
    const [serviceData, setServiceData] = useState({})
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const handleCancel = () => {
        // history.push("/market/Detail?serviceId=" + props.data.service_id)
        setIsModalOpen(false);
    };

    useEffect(() => {
      if (isModalOpen) {
        dispatch(guestGetServicev2({service_id:props.data.service_id, tenant_id: JSON.parse(localStorage.getItem('LoginInfo')).tenantId})).then(resp =>{
          setServiceData(resp.data.services[0])
        }
        )
      }
    }, [isModalOpen])

    const handlePreorder = () => {
        console.log(props.data.subscription_id)
        console.log(props.data.keyword_tw)
        setLoading(true)
        dispatch(preorderCreate({ service_id: props.data.service_id })).then(
            res => {
            setLoading(false)
            if (res.status !== "Failed.") {
                window.location.href = `/Subscribe/preorder?serviceId=${props.data.service_id}&preorderId=${res.data.preorder_id}`
            } else {
                message.error(`${res.messages[0].tw}`)
            }
            }

        )
    }


    return (
        <Modal
        visible={isModalOpen}
        title={t('MarketDetail.Check')}
        onCancel={handleCancel}
        footer={[
          <Button key="submit" type="primary" loading={loading} onClick={handlePreorder}>
            {t('MarketDetail.Submit')}
          </Button>,
        ]}
        >
        {
          serviceData && serviceData !== {} ?
          <div style={{ width: "100％", height: "auto" }}>
          <div style={{ width: "100％", "paddingBottom": "20px" }}>
            <div style={{ fontSize: "16px", fontWeight: "600" }}>
              {t('MarketDetail.Confirm')}
            </div>
            <div style={{ fontSize: "16px", fontWeight: "600" }}>
              {JSON.parse(localStorage.getItem('LoginInfo')) ? JSON.parse(localStorage.getItem('LoginInfo')).account : null}
            </div>
          </div>
          <div style={{ width: "100％", height: "auto", padding: "20px", display: 'flex', border: "solid 0.5px #C7C7C7" }}>
            <div style={{ width: "40%", height: "100px", display: "flex" }}>
              <div style={{ margin: "auto", width: "100px", height: "100px", border: "solid 0.5px #C7C7C7", display: "flex", backgroundColor: "#FFF" }}>
                <img style={{ width: "90%", margin: "auto" }} alt='test' src={serviceData.icon_url} />
              </div>
            </div>
            <div style={{ width: "calc(100% - 100px)", height: "auto", display: "block", position: "relative" }}>
              <div style={{ fontSize: "20px", fontWeight: "600" }}>
                {serviceData && serviceData !== {} && serviceData.service_info_data_en ? localStorage.getItem('lang') === 'en' ? `${serviceData.service_info_data_en[0].service_name}` : `${serviceData.service_info_data_tw[0].service_name}` : ''}
              </div>
              <div>
                {localStorage.getItem('lang') === 'en' ? `${t('Subscription.Card.by')} ${serviceData.vendor_name_en}` : `${t('Subscription.Card.by')} ${serviceData.vendor_name_tw}`}
              </div>
              <div style={{ color: "#7DB926", marginBottom: 20 }}>
                {`#${localStorage.getItem('lang') === 'en' ? serviceData.service_type_en : serviceData.service_type_tw}`}
              </div>
    
              <div>{localStorage.getItem('lang') === 'en' ? 'Pricing' : '定價'}</div>
                <div style={{ width: "100％", height: "50px", padding: "10px", display: 'flex', border: "solid 0.5px #C7C7C7" }}>
                  <div style={{ margin: "auto", fontWeight: "600" }}>
                    {serviceData && serviceData !== {} && serviceData.overview_data ? 
                    localStorage.getItem('lang') === 'en' ? serviceData.overview_data[0].subscription_type_en : serviceData.overview_data[0].subscription_type_tw : ''
                    }
                  </div>
                </div>
            </div>
          </div>
    
          <div style={{ width: "100％", marginTop: "20px", height: "auto", padding: "10px", display: 'flex', border: "solid 0.5px #C7C7C7" }}>
              <div style={{fontWeight: "600" }}>
              <div className='' style={{ color: '#3F3F3F' }}>
              <div>
                  {serviceData.support_data_v2 ? serviceData.support_data_v2.map(i => {
                    //console.log(i.info.en.col_name)
                    if (i.info.en.col_name === "Service Agreement" || i.info.en.col_name === "Privacy Policy") {
                      return (
                        <div className='block'>
                            <div style={{ color: '#3F3F3F' }}>
                              {i.info[localStorage.getItem('lang')].col_val.split(/\s?{link[1-9]}+{link[1-9]_title(.*?)}\s?/g).map((item, index) => {
                                // console.log(index,item)
                                if (index % 2 === 1) {
                                  // console.log((index+1) / 2 )
                                  return (<a style={{ color: "#7DB926" }} onClick={() => window.open(`${i.info[localStorage.getItem('lang')][`link${(index + 1) / 2}`]}`)}>
                                    {i.info[localStorage.getItem('lang')][`link${(index + 1) / 2}_title`]}
                                  </a>)
                                } else {
                                  //console.log(item)
                                  return (
                                    <>{item}</>
                                  )
                                }
                              })
                              }
                            </div>
                        </div>
                      )
                    }
    
                  }) :
                  null}
                </div>
                </div>
              </div>
            </div>
            
            <div style={{ width: "100％", marginTop: "20px", height: "auto", padding: "10px", display: 'flex', border: "solid 0.5px #C7C7C7" }}>
              <div style={{ margin: "auto", fontWeight: "600" }}>
              <div className='' style={{ color: '#3F3F3F' }}>
                <div className=''>
                  {
                    localStorage.getItem('lang') === 'en' ?
                    <>By choosing to submit the order, you agree to place an order with Weyzen Cloud Marketplace for the aforementioned services. <span style={{ color: "#6fa8dc", textDecoration: "underline" }}>Please stamp and return the quotation within 10 days and complete the payment</span>. After payment has been made, our company will proceed with the service activation in accordance with the content of the quotation.</> :
                    <>選擇提交訂單即代表你同意向緯謙智慧雲市集訂購上述服務，<span style={{ color: "#6fa8dc", textDecoration: "underline" }}>請將報價單10日內蓋章遷回並完成付款</span>，待付款後，本公司將依報價單內容完成服務開通作業。</>
                  }
                </div>
                </div>
              </div>
            </div>
          </div> : null
        }
        </Modal>
    )
  }

  const handletoservice = () => {
    console.log(props.data)
    if (JSON.parse(localStorage.getItem('LoginInfo'))) {
      history.push({
        pathname: `/market/contact`,
        state: props.data
      })
    } else {
      sessionStorage.setItem('contact', JSON.stringify(props.data))
      history.push({
        pathname: `/auth/login`
      })
    }

  }
  const onMouseOver = () => {
    if (ref.current.clientHeight > 50) {
      setHeight(ref.current.clientHeight - 30)
    }
  }
  const handleHoverOff = () => {
    setHeight(50)
  }

  const handleservice = () => {
    props.storageData(
      {
        data: {
          service: props.data,
        }
      }
    )
    if (props.type === 'list') {
      // service id
      console.log(props.data.service_id)
      const url = new URL(window.location.href)
      const searchValue = url.searchParams.get("search") ? url.searchParams.get("search") : ""
      history.push(`/portal/service/Detail?serviceId=${props.data.service_id}&search=${searchValue}`)
    }
    // else {
    //     history.push('/portal/service')
    // }
  }
  const handleCost = () => {
    console.log(props.data.subscription_id)
    console.log(props.data.keyword_tw)
    window.location.href = `/portal/cost?search=${props.data.keyword_en}&subId=${props.data.subscription_id}`
  }

  const handlePreorder = () => {
    console.log(props.data.subscription_id)
    console.log(props.data.keyword_tw)
    dispatch(preorderCreate({ service_id: props.data.service_id })).then(
      res => {
        if (res.status !== "Failed.") {
          window.location.href = `/Subscribe/preorder?serviceId=${props.data.service_id}&preorderId=${res.data.preorder_id}`
        } else {
          message.error(`${res.messages[0].tw}`)
        }
      }

    )
  }
  const handletoSubscription = () => {
    setLoadingStatus(() => true)
    setLoading(true)
    dispatch(toSubscription({
      "tenant_id": JSON.parse(localStorage.getItem('LoginInfo')).tenantId,
      "ip_address": "1.1.1.1",
      "operator_id": JSON.parse(localStorage.getItem('LoginInfo')).operator_id,
      "refresh_token": JSON.parse(localStorage.getItem('refresh_token')),
      "subscription_id": props.data.subscription_id
    })).then(res => {
      setLoading(false)
      if (res.code === 200) {
        localStorage.setItem('refresh_token', JSON.stringify(res.data.refresh_token));
        localStorage.setItem('redirect', JSON.stringify(res.data));
        window.open("/portal/service/Redirect", "_blank");
      }
      // else{
      //     message.error({
      //         content:"發生錯誤請聯絡系統人員",
      //         className:"popupmessage"
      //       }
      //     );
      // }

    })
  }


  const menu = (
    <Menu>
      {props.data?.status === 'active' ?
        (
          process.env.REACT_APP_ENV === "staging" && props.data.isv_url_stage ? 
          <>
            <Menu.Item key="0">
              <a target="_blank" rel="noopener noreferrer" onClick={handletoSubscription}>
                {t('Subscription.Card.manage_on_provider')}
              </a>
            </Menu.Item>
            <Menu.Divider />
          </> : process.env.REACT_APP_ENV === "production" && props.data.isv_url_prod ?
            <>
            <Menu.Item key="0">
              <a target="_blank" rel="noopener noreferrer" onClick={handletoSubscription}>
                {t('Subscription.Card.manage_on_provider')}
              </a>
            </Menu.Item>
            <Menu.Divider />
          </> : null
        )
        : null
      }
      {/* <Menu.Item key="1">
            <a target="_blank" rel="noopener noreferrer" href="">
              {t('Subscription.Card.authentication_settings')}
            </a>
          </Menu.Item>
          <Menu.Divider/> */}
      {
        ifForm ? <><Menu.Item key="1">
          <a target="_blank" rel="noopener noreferrer" 
          // onClick={handletoservice}
          onClick={()=>window.open(`mailto:appservice@wiadvance.com`)}
          >
            {t('MarketDetail.ContactMe')}
          </a>
        </Menu.Item>
        </> : null
      }
      <Menu.Item key="2">
        <a rel="noopener noreferrer" onClick={handleCost}>
          {t('Subscription.Card.view_billing_information')}
        </a>
      </Menu.Item>
      {
        ifpreorder ?
          <Menu.Item key="3">
            <a rel="noopener noreferrer" onClick={() => setIsModalOpen(true)}>
              {localStorage.getItem('lang') === 'en' ? "Preorder" : "續訂"}
            </a>
          </Menu.Item> : <></>

      }
      {/* <Menu.Divider/>
          <Menu.Item key="3">
            <a target="_blank" rel="noopener noreferrer" href="">
            {t('Subscription.Card.cancel_subscription')}
            </a>
          </Menu.Item> */}
    </Menu>
  );

  return (
    <>
      {/* <Spin tip={t('Global.Loading')} spinning={loading} style={{padding: '36px 0 0 130px'}}> */}
      <div className='servicelayout' style={{ width: '100%' }}>
        <div className='servicecard' style={{ height: height + 150, width: '100%' }}>
          <div className='marginblock'>
            {props.type === 'list' ? <a onClick={handleservice}>
              <div className='serviceimg'>
                <img className='imgmid' alt='test' src={props.data.icon_url} />
              </div>
            </a> :
              <div className='serviceimg'>
                <img className='imgmid' alt='test' src={props.data.icon_url} />
              </div>
            }
            <div className='serviceinfo'>
              <div className='servicename'>
                <div className='title'>
                  {props.type === 'list' ?
                    <a color='black' onClick={handleservice}>
                      {localStorage.getItem('lang') === 'en' ? `${props.data.service_name_en}` : `${props.data.service_name_tw}`}
                    </a> : <>{localStorage.getItem('lang') === 'en' ? `${props.data.service_name_en}` : `${props.data.service_name_tw}`}</>
                  }
                </div>
                {
                  props.type !== 'market' ?
                    <div className='status'>
                      <div className='date'>
                        {`${props.data.period_start} ~ ${props.data.period_end}`}
                      </div>
                      <div className='block' />
                      {
                        props.subscription ? null : <span className="navbar__link">
                          |
                        </span>
                      }

                      <div className='block' />
                      <div className='state'>
                        {localStorage.getItem('lang') === 'en' ? props.data.sub_status.status_desc_en : props.data.sub_status.status_desc_tw}
                      </div>
                    </div> :
                    <></>
                }
              </div>
              <div className='servicedes'>
                <div className='left'>
                  <div className='servicetag'>
                    <div className='isvname'>
                      {localStorage.getItem('lang') === 'en' ? `${t('Subscription.Card.by')} ${props.data.vendor_name_en}` : `${t('Subscription.Card.by')} ${props.data.vendor_name_tw}`}
                    </div>
                    <div className='tag'>
                      {`#${localStorage.getItem('lang') === 'en' ? props.data.service_type_en : props.data.service_type_tw}`}
                    </div>
                  </div>
                  {/* <div className='servicerole'>
                                <Rate 
                                    allowHalf
                                    disabled defaultValue={props.data.rate} 
                                />
                                <div className='reviews'>
                                    {`${props.data.reviews} Reviews`}
                                </div>
                            </div> */}
                  <div className='description' ref={ref} onMouseOver={onMouseOver} onMouseLeave={handleHoverOff}>
                    <div contentEditable='false' dangerouslySetInnerHTML={{ __html: `${localStorage.getItem('lang') === 'en' ? `${props.data.summary_en}` : `${props.data.summary_tw}`}` }}></div>
                  </div>
                </div>
                <div className='right'>
                  <div className="button">
                    {/* {
                                props.type === 'list'?
                                <Button type="primary" onClick={handleservice}>
                                    {t('Subscription.Card.go_to_service')}
                                </Button>:
                                <Button type="primary" onClick={handleservice}>
                                    {t('Subscription.Card.return')}
                                </Button>
                                } */}
                    <div className='block' />
                    {
                      props.type === "market" ?
                        <Button loading={LoadingStatus} type="primary" onClick={handletoSubscription}>
                          <Space>
                            {t('Subscription.Card.subscribe')}
                          </Space>
                        </Button> :
                        <Dropdown overlay={menu} trigger={['click']}>
                          <Button type="primary">
                            <Space>
                              {t('Subscription.Card.actions')}
                              <CaretDownFilled />
                            </Space>
                          </Button>
                        </Dropdown>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </Spin> */}
      <ServiceCardModal />
    </>
  )
}
const mapStateToProps = store => (
  { storeData: store.storeData }
)
const mapDispatchToProps = dispatch => {
  return {
    storageData: (payload) => {
      dispatch(storageData(payload))
    },
    clearstorageData: () => {
      dispatch(clearstorageData())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ServiceCard))